<template>
  <div>
    <el-tooltip :content="$t('accountProps.create.btnTooltip')"
                effect="light"
                :open-delay="300"
                placement="bottom">
      <base-button size="md" icon round type="primary" @click="modal = true" class="zi_100">
        <span class="mdi mdi_icon mdi-24px mdi-plus"/>
      </base-button>
    </el-tooltip>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()"
           key="accountProps.create">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('accountProps.create.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('accountProps.create.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{
                $t('generic.type')
              }}</label>
            <div class="col-sm-9">
              <base-input
                :error="getError('type')">
                <el-select
                  name="type"
                  data-vv-as="'type'"
                  class="select-primary"
                  v-validate="modelValidations.required"
                  v-model="formDetails.type">
                  <el-option
                    v-for="option in availableAccountPropTypes"
                    class="select-primary"
                    :value="option"
                    :label="$t('accountProps.knownPropTypes.'+option)"
                    :key="option">
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('accountProps.details.value') }}</label>
            <div class="col-sm-9">
              <base-input
                type="text"
                name="value"
                :error="getError('value')"
                v-validate="modelValidations.required"
                v-model="formDetails.value" />
            </div>
          </div>

          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('accountProps.create.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'CreateAccountAdditionalPropBtn2',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      modal: false,
      alert: false,
      loading: false,
      formDetails: {
        type: 'owner',
        value: ''
      },
      modelValidations: {
        required: {
          required: true
        },
      },
    }
  },
  computed: {
    ...mapState({
      updating: state => state.account_props.updating,
      error: state => state.account_props.error,
      data: state => state.account_props.data,
      availableAccountPropTypes: state => state.account_props.availableTypes,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    }
  },
  methods: {
    ...mapActions(['CreateAccountProps', 'LoadAccountProps']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    create: function () {
      let payload = {
        type: this.formDetails.type,
        value: this.formDetails.value,
      }

      this.CreateAccountProps({accountId: this.accountId, data: payload}).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('accountProps.create.successNotification'),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.LoadAccountProps(this.accountId)
          this.resetForm();
        }
      });
    },
    resetForm: function () {
      // closing dialog
      this.modal = false;

      // resetting alerts
      this.alert = false;

      // resetting form
      this.formDetails = {
        type: 'owner',
        value: '',
      },

        // reset validation errors
        this.$validator.reset()
    }
  }
}
</script>
